export default "__VITE_ASSET__8yzw3qVN__"